import React from "react";
import "./Articledetails.css";

const Articledetails = ({ children, onClose }) => {
  return (
    <div className="articledetails" onClick={onClose}>
      <div
        className="articledetails-content"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="close-button" onClick={onClose}>
          X
        </div>
        <div className="articledetails-content-param">{children}</div>
      </div>
    </div>
  );
};

export default Articledetails;
